export default {
  ira_2018: {
    name: "Russian IRA (2018)"
  },
  iran_2018: {
    name: "Iran (2018)"
  },
  china_2019_1: {
    name: "China #1 (2019)"
  }
};
